import {connect} from 'react-redux';
import React, {Component} from 'react';

import FbShare from "../FbShare";
import CallbackBanner from "../CallbackBanner";
import RequestForPurchase from "./RequestForPurchase";

class Sidebar extends Component {
    render() {
        const i18n = this.props.languages.i18n;
        return (
            <div className="sidebar">
                <RequestForPurchase/>
                <CallbackBanner btnTitle={i18n['objectPage.requestForPurchase']} className="light"/>
                <FbShare/>
            </div>
        )
    }
}

const mapStateToProps = state => {
    const languages = state.languages;
    const objectPage = state.objectPage;

    return {
        languages,
        objectPage
    };
};

const mapDispatchToProps = {
};

export default connect(mapStateToProps, mapDispatchToProps)(Sidebar);


// WEBPACK FOOTER //
// ./src/components/PropertyPage/Buy/Sidebar.js